export default __webpack_public_path__ + "static/media/29_TopRightSquares_Flip.cfcb20b2.mp4";